import { movies } from "@/mocks/movies";
import { getByCategory, sortMovies } from "@/utils/movies";
import { useSEO } from "@/hooks/useSEO";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import MovieGridSection from "@/pages/home/components/MovieGridSection";
import LatestList from "@/pages/home/components/LatestList";
import RankingList from "@/pages/home/components/RankingList";
import PlatformIntro from "@/pages/home/components/PlatformIntro";

const HOME_TITLE = "色虎视频 - 高清影视资源聚合平台";
const HOME_DESC =
  "色虎视频为您提供丰富的影视资源，包括最新电影、热门电视剧和多样视频内容，满足您的观影需求。这里汇聚海量影视作品，方便您随时在线观看和内容发现。";

export default function Home() {
  useSEO(HOME_TITLE, HOME_DESC);

  const hotMovies = sortMovies(movies, "hot").slice(0, 10);
  const latestMovies = sortMovies(movies, "new").slice(0, 6);
  const topRated = sortMovies(movies, "rating").slice(0, 5);
  const hotTv = sortMovies(getByCategory(movies, "tv"), "hot").slice(0, 5);

  return (
    <div className="pb-4">
      <HeroCarousel movies={movies} />

      <div className="mt-8 md:mt-10">
        <CategoryQuickLinks />
      </div>

      <div className="mt-12 md:mt-16">
        <MovieGridSection
          title="热门影视推荐"
          subtitle="近期最受欢迎的影视资源精选"
          movies={hotMovies}
          moreHref="/search"
        />
      </div>

      <div className="mt-12 md:mt-16">
        <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <LatestList movies={latestMovies} moreHref="/search" />
          </div>
          <RankingList movies={topRated} />
        </div>
      </div>

      <div className="mt-12 md:mt-16">
        <MovieGridSection
          title="热播剧集"
          subtitle="正在热播的口碑电视剧"
          movies={hotTv}
          moreHref="/category/tv"
        />
      </div>

      <div className="mt-12 md:mt-16">
        <PlatformIntro />
      </div>
    </div>
  );
}